/* global axios */
import ApiClient from '../ApiClient';

class AssistantSettings extends ApiClient {
  constructor() {
    super('assistant/settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data = {}) {
    return axios.patch(this.url, { settings: data });
  }

  // Р78: живая проверка подключения — генерация и эмбеддинг.
  healthCheck() {
    return axios.post(`${this.url}/health_check`);
  }
}

export default new AssistantSettings();
